import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import InputCst from "@components/InputCst/InputCst";
import SelectCst from "@components/InputCst/SelectCst";
import DataPickerCst from "@components/InputCst/DataPickerCst";
import { DynamicFilterProps } from "./types";

const DynamicFilterCst: React.FC<DynamicFilterProps> = ({
  field,
  value,
  onChange,
}) => {
  const { i18n } = useTranslation();
  const lang = i18n.language === "en" ? "en" : "it";
  const label =
    field.headerLabels?.[lang] || field.headerLabels?.en || field.key;

  const radiusWrapperSx = {
    width: "100%",
    minWidth: 0,

    "& > *": {
      minWidth: "0 !important",
      width: "100% !important",
    },
    "& .MuiFormControl-root": {
      minWidth: "0 !important",
      width: "100% !important",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "8px",
    },
  };

  if (field.type === "select") {
    return (
      <Box sx={radiusWrapperSx}>
        <SelectCst
          id={`filter-${field.key}`}
          label={label}
          value={value ?? ""}
          optionsKey={field.optionsKey}
          onChange={(next: any) => onChange(next === "" ? null : next)}
          isFilterActive={!!value}
          customWidth="100%"
        />
      </Box>
    );
  }

  if (field.type === "date") {
    return (
      <Box sx={radiusWrapperSx}>
        <DataPickerCst
          id={`filter-${field.key}`}
          label={label}
          value={value ?? null}
          onChange={(next: any) => {
            if (!next) {
              onChange(null);
              return;
            }

            const date = new Date(next);
            const dateUTC = Date.UTC(
              date.getFullYear(),
              date.getMonth(),
              date.getDate(),
              0,
              0,
              0,
            );
            onChange(new Date(dateUTC).toISOString());
          }}
          isFilterActive={!!value}
          customWidth="100%"
        />
      </Box>
    );
  }

  return (
    <Box sx={radiusWrapperSx}>
      <InputCst
        id={`filter-${field.key}`}
        label={label}
        value={value ?? ""}
        onChange={(e: any) => onChange(e.target.value || null)}
        isFilterActive={!!value}
        customWidth="100%"
      />
    </Box>
  );
};

export default DynamicFilterCst;
